// removed by extract-text-webpack-plugin
module.exports = {"partners-wrap":"partners-wrap___2Ygha center___2iqBf h2___hzLuT","partner-logo-img-flex":"partner-logo-img-flex___1sESb center___2iqBf","partner-logo-img":"partner-logo-img___3hdBv","partner-logo-img-lg":"partner-logo-img-lg___g7jJF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesPartnerLogos/TargetDateSeriesPartnerLogos.css
// module id = 934
// module chunks = 0